"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPreviousButton = exports.StyledNextButton = exports.StyledButtonContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledButtonContainer = exports.StyledButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled-buttons__StyledButtonContainer",
  componentId: "sc-143c0zd-0"
})(["display:flex;position:relative;align-self:stretch;align-items:center;justify-content:center;background:var(--color-global-grey200);width:4.4rem;"]);
var StyledButton = _styledComponents["default"].div.withConfig({
  displayName: "styled-buttons__StyledButton",
  componentId: "sc-143c0zd-1"
})(["display:none;@media not all and (pointer:coarse){display:flex;align-items:center;position:absolute;top:0;height:100%;}"]);
var StyledPreviousButton = exports.StyledPreviousButton = (0, _styledComponents["default"])(StyledButton).attrs({
  className: 'fuse-tabs__previous-button',
  'data-testid': 'fuse-tabs-previous-button-test-id'
}).withConfig({
  displayName: "styled-buttons__StyledPreviousButton",
  componentId: "sc-143c0zd-2"
})(["left:0;&.hidden{display:none;}"]);
var StyledNextButton = exports.StyledNextButton = (0, _styledComponents["default"])(StyledButton).attrs({
  className: 'fuse-tabs__next-button',
  'data-testid': 'fuse-tabs-next-button-test-id'
}).withConfig({
  displayName: "styled-buttons__StyledNextButton",
  componentId: "sc-143c0zd-3"
})(["right:0;&.hidden{display:none;}"]);